import styled, { css } from 'styled-components'
import Box from 'components/Box'

const DropdownHeader = styled(Box)(
  ({ theme: { colors, fontWeights, fontSizes } }) => css`
    margin-left: 20px;
    padding: 8px 0;

    color: ${colors.foreground.secondary[4]};
    font-size: ${fontSizes.tiny};
    font-weight: ${fontWeights.semibold};

    text-align: left;
    text-transform: uppercase;
    pointer-events: none;
  `
)

export default DropdownHeader
